export default "__VITE_ASSET__a4627178__"